export const _roundWizardTypes = {
  createRoundMatches: 'createRoundMatches',
  editDate: 'editDate',
  showCourses: 'showCourses',
  editLineup: 'editLineup',
}

export const _roundAllows = Object.freeze({
  allowOpenScoring: 'allowOpenScoring',
  roundIsActive: 'roundIsActive',
  roundIsDemo: 'roundIsDemo',
  allowLiftCleanAndPlaceAnywhere: 'allowLiftCleanAndPlaceAnywhere',
  allowLiftCleanAndPlaceFairways: 'allowLiftCleanAndPlaceFairways',
  allowLiftCleanAndPlaceBunkers: 'allowLiftCleanAndPlaceBunkers',
})

export const golfRoundReducer = (state, action) => {

  const { type } = action

  switch (type) {


    case rts.handleAmmend_golfRound:
      return {
        ...state,
        name: _.startCase(action.roundKey),
        roundKey: action.roundKey,
        roundStatus: action.roundStatus,
        roundMatches: action.roundMatches,
        matches_round: action.roundMatches,
      }

    case rts.handleShow_roundWizard:
      return { ...state, showRoundWizard: !state.showRoundWizard, roundWizardProps: action.roundWizardProps }

    case rts.handleShow_reducedHandicap:
      action.e && action.e.stopPropagation()
      return { ...state, showReducedHandicap: !state.showReducedHandicap }

    case rts.handleShow_scorecards:
      action.e && action.e.stopPropagation()
      return { ...state, showScorecards: !state.showScorecards }

    case rts.handleShow_roundLead:
      return { ...state, showLead: state.showLead === action.lead ? null : action.lead }

    case rts.handleAmmend_matchUpdater:
      const _matchUpdaters = _.clone(state.matchUpdaters)
      let mu = _matchUpdaters
      if (action.removeItem) {
        mu = _.filter(
          _matchUpdaters,
          (num) => num !== action.nextMatch?.matchNumber
        )
      } else {
        _matchUpdaters.push(action.nextMatch?.matchNumber);
        mu = _matchUpdaters
      }
      return { ...state, matchUpdaters: mu };

    case rts.handleAmmend_selectedMatchKeys:
      const key = action.selectedMatchKey;
      let _selectedMatchKeys = _.clone(state.selectedMatchKeys);

      if (_.includes(_selectedMatchKeys, key)) {
        // remove if exists
        _selectedMatchKeys = _.without(_selectedMatchKeys, key);
      } else {
        // add if missing
        _selectedMatchKeys.push(key);
      }

      return { ...state, selectedMatchKeys: _selectedMatchKeys };

    default:
      return { ...state }
  }
}

export const golfRoundHandlers = (dispatch) => {
  return {
    handleAmmend_selectedMatchKeys: (selectedMatchKey) => { dispatch({ type: rts.handleAmmend_selectedMatchKeys, dispatch, selectedMatchKey }) },
    handleAmmend_golfRound: (roundKey, roundStatus, roundMatches) => { dispatch({ type: rts.handleAmmend_golfRound, dispatch, roundKey, roundStatus, roundMatches }) },
    handleAmmend_matchUpdater: (nextMatch, removeItem) => { dispatch({ type: rts.handleAmmend_matchUpdater, dispatch, nextMatch, removeItem }) },
    handleShow_reducedHandicap: (e) => { dispatch({ type: rts.handleShow_reducedHandicap, dispatch, e }) },
    handleShow_roundLead: (lead) => { dispatch({ type: rts.handleShow_roundLead, dispatch, lead }) },
    handleShow_roundWizard: (roundWizardProps) => { dispatch({ type: rts.handleShow_roundWizard, dispatch, roundWizardProps }) },
    handleShow_scorecards: (e) => { dispatch({ type: rts.handleShow_scorecards, dispatch, e }) },
  }
}

export const rts = {
  handleAmmend_golfRound: 'handleAmmend_golfRound',
  handleAmmend_matchUpdater: 'handleAmmend_matchUpdater',
  handleAmmend_selectedMatchKeys: 'handleAmmend_selectedMatchKeys',
  handleShow_reducedHandicap: 'handleShow_reducedHandicap',
  handleShow_roundLead: 'handleShow_roundLead',
  handleShow_roundWizard: 'handleShow_roundWizard',
  handleShow_scorecards: 'handleShow_scorecards',
}

export const golfRoundInitialState = (init_state) => {
  return {
    ...init_state,
    matchUpdaters: [],
    selectedMatchKeys: [],
    _propAllows: _roundAllows
  }
};

const getHoleWinnerTimeline = (round) => {
  // Flatten
  const events = _.flatMap(round, (match, matchKey) =>
    _.map(match.holeWinners, (holeWinner, holeNumber) => ({
      matchKey,
      holeNumber: Number(holeNumber),
      winningTeam: holeWinner.winningTeam,
      createdAt: holeWinner.createdAt
    }))
  );

  // Sort by createdAt
  return _.sortBy(events, "createdAt");
};
